import {
  IMAGE_MAPPING,
  InstanceOrientation,
  MODALITY,
  MedicalImagesKey,
  MedicalImagesType,
} from "../enums/MedicalImagesEnum";

export const extractBiplaneInfo = metadata => {
  if (metadata["00080008"]) {
    const imageType = metadata["00080008"].split("\\");
    const biplaneInfo = imageType.find(item => item.startsWith("BIPLANE"));
    if (biplaneInfo) {
      const biplaneValue = biplaneInfo.split(" ")[1];
      if (biplaneValue === "B") {
        return IMAGE_MAPPING.SAGITTAL;
      } else if (biplaneValue === "A") {
        return IMAGE_MAPPING.CORONAL;
      }
    }
  }
  return null;
};

//TODO: REVIEW THE ORIENTATION LOGIC TO BE CONSISTENT
export const convertKey = (modality, orientation) => {
  const normalized_modality = modality?.toLowerCase();
  const normalized_orientation = orientation?.toLowerCase();

  switch (modality) {
    case MODALITY.DX:
    case MODALITY.CR: {
      // Extract the base orientation from strings like "Coronal RL" or "Sagittal PA"
      let baseOrientation;
      if (normalized_orientation?.includes(InstanceOrientation.Coronal)) {
        baseOrientation = InstanceOrientation.Coronal;
      } else if (
        normalized_orientation?.includes(InstanceOrientation.Sagittal)
      ) {
        baseOrientation = InstanceOrientation.Sagittal;
      } else {
        // Handle NIfTI JSON orientation format: {"row_left":"L","column_bottom":"I"}
        // row_left L/R → coronal (frontal); row_left A/P → sagittal (lateral)
        try {
          const orientObj = JSON.parse(orientation);
          const rowLeft = orientObj.row_left?.toUpperCase();
          if (rowLeft === "L" || rowLeft === "R") {
            baseOrientation = InstanceOrientation.Coronal;
          } else if (rowLeft === "A" || rowLeft === "P") {
            baseOrientation = InstanceOrientation.Sagittal;
          }
        } catch (e) {
          // Not JSON format, fall through
        }
        if (!baseOrientation) {
          baseOrientation = normalized_orientation;
        }
      }

      return MedicalImagesKey[baseOrientation];
    }

    case MODALITY.CT:
    case MODALITY.MR:
      return MedicalImagesKey[normalized_modality];

    default:
      return MedicalImagesKey.sagittal;
  }
};
// New function that returns both frontend and backend keys
export const convertKeys = (modality, orientation) => {
  const standardKey = convertKey(modality, orientation).toUpperCase();

  // Map frontend keys to backend keys for custom measurements
  const getCustomMeasurementsKey = (modality, orientation) => {
    const normalized_orientation = orientation?.toLowerCase();

    switch (modality) {
      case MODALITY.DX:
      case MODALITY.CR:
        // Use the same logic as convertKey function
        if (normalized_orientation?.includes(InstanceOrientation.Sagittal)) {
          return MedicalImagesType.LATERALDX;
        } else if (
          normalized_orientation?.includes(InstanceOrientation.Coronal)
        ) {
          return MedicalImagesType.FRONTDX;
        } else {
          // Handle NIfTI JSON orientation format
          try {
            const orientObj = JSON.parse(orientation);
            const rowLeft = orientObj.row_left?.toUpperCase();
            if (rowLeft === "A" || rowLeft === "P") return MedicalImagesType.LATERALDX;
            if (rowLeft === "L" || rowLeft === "R") return MedicalImagesType.FRONTDX;
          } catch (e) {
            // Not JSON
          }
          return MedicalImagesType.FRONTDX;
        }
      case MODALITY.CT:
        return MedicalImagesType.VOLUME;
      default:
        return normalized_orientation?.includes(InstanceOrientation.Sagittal)
          ? MedicalImagesType.LATERALDX
          : MedicalImagesType.FRONTDX;
    }
  };

  const customKey = getCustomMeasurementsKey(modality, orientation);

  return {
    standard: standardKey,
    custom: customKey,
    key: standardKey.toLowerCase(),
  };
};
